export default "__VITE_ASSET__CpYJMui___";